import styled from '@emotion/styled';

import meals from '../../assets/helfy-meals.jpg';
import { breakpoint } from '../../style/utils';
import { colours } from '../../style/variables';
import { ButtonOutboundLink } from '../Button';

const verticalBreakpoint = breakpoint({ max: 'sm' });

export const HelfyAdvertRoot = styled.div`
  display: flex;
  position: relative;
  min-height: 480px;
  background-color: ${colours.cream};

  @media ${verticalBreakpoint} {
    flex-direction: column;
  }
`;

export const ImageSection = styled.a`
  position: relative;
  z-index: 1;
  display: block;
  flex: 1 1 50%;
  min-height: 320px;
  background-image: url("${meals}");
  background-size: cover;
  background-position: center;

  @media ${verticalBreakpoint} {
    flex: 0 0 320px;
    order: -1;
  }
  @media ${breakpoint({ max: 'xs' })} {
    flex: 0 0 240px;
  }
`;

export const TextSection = styled.div`
  position: relative;
  z-index: 1;
  flex: 1 0 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 64px 40px;

  @media ${verticalBreakpoint} {
    flex: 0 0 auto;
    padding: 48px 24px;
  }
`;

export const AdvertHeading = styled.h2`
  margin: 28px 0 32px;
  max-width: 460px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${colours.black};

  @media ${breakpoint({ max: 'md' })} {
    font-size: 36px;
  }
`;

export const WebsiteLinkButton = styled(ButtonOutboundLink)`
  border-radius: 999px;
`;
